











































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import { ResumeWrapper } from '../models/jobs/resumeWrapper';
import { Resume } from '../models/jobs/resume';
import { ResumeRecord } from '../models/jobs/resumerecord';
import { ResumePayload } from '../models/jobs/resumepayload';

import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'ResumeDetails',
  components: {
    Datepicker,
  },
})
export default class ResumeDetails extends Vue {
  $wlToastr: any;
  private resumeListing: ResumeWrapper = new ResumeWrapper();
  private resumePayload: ResumePayload = new ResumePayload();
  private currentResumeName: string = '';
  private currentResume: ResumeRecord = new ResumeRecord();
  private selectedResume: ResumeRecord = new ResumeRecord();
  private selectedResumes: any;
  private errorString: string = '';
  //new variables
  private showUploadText: boolean = true;
  private selectedNewResume: ResumeRecord = new ResumeRecord();
  private supportedFileSize = 0;
  private isResumeFileSelected: boolean = false;
  @Prop() showResumeSection;

  get isLoggedIn() {
    console.log('url', this.thisURL);
    return vxm.users.isLoggedIn;
  }

  get SelectedResume(): ResumeRecord {
    return this.selectedResume;
  }

  get thisURL() {
    return window.location.href.split('/')[
      window.location.href.split('/').length - 1
    ];
  }

  resumeSelected(resume) {
    this.selectedResume = resume;
  }

  get ResumeListing(): ResumeWrapper {
    if (this.resumeListing && this.resumeListing.resumes) {
      this.resumeListing.resumes.forEach((element) => {
        if (element.defaultResume) {
          this.selectedResume = element;
        }
      });
    }
    return this.resumeListing;
  }

  selectResume(resume: ResumeRecord) {
    this.selectedResume = resume;
  }

  renameResume(resume: ResumeRecord) {
    if (resume) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('resume.label.renameresume'),
        );
      } else {
        this.currentResume = resume;
        this.currentResumeName = resume.name;
        this.$modal.show('rename-resume');
      }
    }
  }

  get allowedResumeFormat() {
    return vxm.configs.getGlobalConfigValue('ALLOWED_RESUME_FORMATS');
  }

  cancelRename() {
    this.$modal.hide('rename-resume');
  }

  async selectFromDropbox() {
    const vm = this;
    vxm.users
      .uploadDropboxResume()
      .then(async (status) => {
        console.log('STATUS:', status);
        if (status === 'success') {
          vm.$wlToastr('success', vm.$t('SkillsDetails_SuccessfullyUploaded'), vm.$t('ResumeDetails_UploadResume'));
          const listPromise = await vxm.jobs.getApplyFlowResumeListing(
            vxm.users.getToken,
          );
          let resumeListings = vxm.jobs.resumeListing;
          if (resumeListings && resumeListings.resumes) {
            let defaultResume = resumeListings.resumes.find(
              (resume) => resume.defaultResume,
            );
            if (!defaultResume) {
              defaultResume = resumeListings.resumes[0];
            }
            this.$emit('resume-upload-text', defaultResume.fileGUID);
            this.resumeSelected(defaultResume);
          }
          this.resumeListing = resumeListings;
          this.showUploadText = !this.showUploadText;
        } else {
          vm.$wlToastr('info', vm.$t('SkillsDetails_CancelUpload'), vm.$t('ResumeDetails_UploadResume'));
        }
      })
      .catch((err) => {
        vm.$wlToastr('error', vm.$t('ResumeDetails_UploadResumeError'), vm.$t('ResumeDetails_UploadResume'));
      });
  }

  async submitRename() {
    const vm = this;
    this.$modal.hide('rename-resume');
    this.currentResume.name = this.currentResumeName;
    const respPromise: any = vxm.users.renameResume(this.currentResume);
    const listPromise = vxm.jobs.getApplyFlowResumeListing(vxm.users.getToken);
    const [resp, list] = await Promise.all([respPromise, listPromise]);

    if (resp.success) {
      this.$wlToastr('success', resp.successMessage, this.$t('resume.label.renameresume'));
      const token = vxm.users.getToken;
      vxm.jobs.getApplyFlowResumeListing(token).then(() => {
        this.resumeListing = vxm.jobs.resumeListing;
      });
    } else {
      this.$wlToastr('error', resp.errorMessage, this.$t('resume.label.renameresume'));
    }
  }

  async deleteResume(resume: ResumeRecord) {
    const vm = this;
    if (resume && resume.defaultResume !== true) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_DeleteResume'),
        );
      } else {
        const respPromise = vxm.users.deleteResume(resume);
        const listPromise = vxm.jobs.getApplyFlowResumeListing(
          vxm.users.getToken,
        );
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        if (resp.success) {
          this.$wlToastr('success', resp.successMessage, this.$t('ResumeDetails_DeleteResume'));
          const token = vxm.users.getToken;
          vxm.jobs.getApplyFlowResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_DeleteResume'));
        }
      }
    } else {
      this.$wlToastr(
        'error',
        this.errorString,
        this.$t('ResumeDetails_DefaultResumeDeleteError'),
      );
    }
  }

  async defaultResume(resume: ResumeRecord) {
    const vm = this;
    if (resume) {
      if (!resume.fileGUID) {
        this.$wlToastr(
          'error',
          this.$t('profile.resume.select.required'),
          this.$t('ResumeDetails_SetDefaultResume'),
        );
      } else {
        const respPromise = vxm.users.defaultResume(resume);
        const listPromise = vxm.jobs.getApplyFlowResumeListing(
          vxm.users.getToken,
        );
        const [resp, list] = await Promise.all([respPromise, listPromise]);

        console.log(['in default resume', resp, list]);
        if (resp.success) {
          this.$wlToastr('success', resp.successMessage, this.$t('ResumeDetails_SetDefaultResume'));

          const token = vxm.users.getToken;
          vxm.jobs.getApplyFlowResumeListing(token).then(() => {
            this.resumeListing = vxm.jobs.resumeListing;
          });
        } else {
          this.$wlToastr('error', resp.errorMessage, this.$t('ResumeDetails_SetDefaultResume'));
        }
      }
    }
  }

  uploadResume() {
    const vm = this;
    const token = vxm.users.getToken;
    this.resumePayload.accessToken = token;
    this.resumePayload.jobpostingid = -1;
    this.resumePayload.resumelink = '';
    console.log(this.resumePayload);
    if (this.validateFileSize(this.resumePayload.resumefile)) {
      if (this.validateUploadResume(this.resumePayload)) {
        const respPromise = vxm.jobs
          .postProfileResume(this.resumePayload)
          .then((resp) => {
            if (resp.success) {
              this.$wlToastr(
                'success',
                this.$t('profile.upload.resume.sucess'),
                this.$t('ResumeDetails_UploadResume'),
              );
              // tslint:disable-next-line:no-shadowed-variable
              const token = vxm.users.getToken;
              vxm.jobs.getApplyFlowResumeListing(token).then(() => {
                let resumeListings = vxm.jobs.resumeListing;
                this.$emit('resume-upload-text', resp.resumeGUID);
                if (resumeListings && resumeListings.resumes) {
                  for (let element of resumeListings.resumes) {
                    if (
                      this.resumePayload &&
                      this.resumePayload.resume &&
                      element.name === this.resumePayload.resume.resumename
                    ) {
                      this.resumeSelected(element);
                    }
                  }
                }
                this.resumeListing = resumeListings;
                this.showUploadText = !this.showUploadText;
              });
            } else if (resp.errorMessage) {
              this.$wlToastr(
                'error',
                resp.errorMessage,
                this.$t('ResumeDetails_UploadResume'),
              );
              
            } else {
              this.$wlToastr(
                'error',
                this.$t('profile.upload.resume.error'),
                this.$t('ResumeDetails_UploadResume'),
              );
            }
          });
      } else {
        this.$wlToastr('error', this.$t(this.errorString), this.$t('ResumeDetails_UploadResume'));
      }
    }
    this.resumePayload.resumefile = '';
    this.isResumeFileSelected = false;
  }

  validateFileSize(file) {
    console.log('validating file size for file : ', file);
    if (file.size > this.supportedFileSize) {
      this.$wlToastr(
        'error',
        this.$t('ResumeDetails_SizeRestriction', { maxSize: this.supportedFileSize / (1024 * 1024) }),
        this.$t('ResumeDetails_UploadResume'),
      );
      return false;
    }
    return true;
  }

  validateUploadResume(resumePayload: ResumePayload): boolean {
    if (!resumePayload.resume.resumename) {
      this.errorString = 'profile.upload.resume.file.required';
      return false;
    }
    if (resumePayload.resume.resumename.length > 250) {
      this.errorString = 'profile.resume.file.name.exceeded';
      return false;
    }

    return true;
  }
  validateFileFormate() {
    const vm = this;
    setTimeout(() => vm.validationFileFormatResume(), 50);
  }

  validationFileFormatResume() {
    const vm = this;
    console.log([vm.resumePayload]);
    this.resumePayload.resume.resumename = vm.resumePayload.resumefile.name;
    // if (this.resumePayload.resume.resumename.length > 250) {
    //   this.$wlToastr(
    //     'error',
    //     'You have exceeded the maximum character limit of 250 characters for file name',
    //     'Upload Resume',
    //   );
    //   return;
    // }

    const ext = vm.resumePayload.resumefile.name.match(/\.([^\.]+)$/)[1];
    const fileNameFormat = vm.resumePayload.resumefile.name.match(
      /\.([^\.]+)$/,
    )[0];

    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    // if (!allowedResumeFormat.includes(ext)) {
    //   this.$wlToastr(
    //     'error',
    //     fileNameFormat +
    //       ` is an unsupported file format. Following file formats are allowed: ${allowedResumeFormat}`,
    //     'Upload Resume',
    //   );
    //   vm.resumePayload.resumefile = '';
    // }
  }

  mounted() {
    const token = vxm.users.getToken;
    if (vxm.users.getToken) {
      vxm.jobs
        .getApplyFlowResumeListing(token)
        .then(() => {
          let resumeListings = vxm.jobs.resumeListing;
          for (let element of resumeListings.resumes) {
            if (element.defaultResume) {
              this.resumeSelected(element);
            }
          }
          this.resumeListing = resumeListings;
          if (
            resumeListings &&
            resumeListings.resumes &&
            resumeListings.resumes.length === 0
          ) {
            this.showUploadText = false;
          }
        })
        .catch((exc) => {
          this.showUploadText = false;
          console.log(exc);
          // Recurrent exception with listing Resumes.
          this.$wlToastr(
            'error',
            this.$t('high-traffic-error'),
            this.$t('MyJobListing_JobApplication'),
          );
        });
    } else {
      this.showUploadText = false;
    }

    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
  }

  //new mthods
  toggleShowUploadText() {
    if (this.showUploadText) {
      this.resumePayload.resumefile = '';
      this.isResumeFileSelected = false;
    }
    this.showUploadText = !this.showUploadText;
  }

  onResumeFileSelected(file) {
    this.isResumeFileSelected = !!file;
  }

  get isDropboxEnabled() {
    if (
      vxm.configs.getGlobalConfigBooelanValue('WL_DROPBOX_INTEGRATION_ENABLED')
    ) {
      if (vxm.configs.getGlobalConfigValue('DROPBOX_APP_KEY')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
}
